import { Typography } from 'aos-ds/src/typography/Typography'
import React from 'react'
import { View } from 'react-native'

import { twMerge } from '../../tailwind/merge'
import { Pressable } from '../pressable'
import { LABEL_VARIANT, resolveFilter } from './filterSwitchContracts'

// The Figma dumper drops the zero-alpha rest stroke that keeps the pill width stable.
export const REST_BORDER_CLASS = 'border border-border-transparent'

export type FilterProps = {
    label: string
    selected: boolean
    onPress(): void
    testID?: string
    measureOnly?: boolean
}

export const Filter = ({ label, selected, onPress, testID, measureOnly = false }: FilterProps) => {
    const cell = resolveFilter(selected ? 'selected' : 'not-selected', 'pill')
    const pillClass = twMerge(selected ? undefined : REST_BORDER_CLASS, cell.container)
    const text = (
        <Typography variant={LABEL_VARIANT} className={cell.label}>
            {label}
        </Typography>
    )
    if (measureOnly) {
        return (
            <View className={pillClass} testID={testID}>
                {text}
            </View>
        )
    }
    return (
        <Pressable
            accessibilityRole='tab'
            accessibilityState={{ selected }}
            onPress={onPress}
            className={twMerge('web:cursor-pointer', pillClass)}
            testID={testID}
        >
            {text}
        </Pressable>
    )
}
